export default __webpack_public_path__ + "static/no-result-image~dZZBxwVc-4949c46e93edc37eda517c73e5d7ccfc.png";